(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dd-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var nodes = document.querySelectorAll('.dd-countdown');
      var now = Date.now();
      for (var i = 0; i < nodes.length; i++) {
        var cd = nodes[i];
        var target = new Date(cd.getAttribute('data-deadline')).getTime();
        if (isNaN(target)) { continue; }
        var diff = target - now;
        if (diff <= 0) { cd.setAttribute('hidden', ''); continue; }
        cd.removeAttribute('hidden');
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var setEl = function (sel, val) { var el = cd.querySelector(sel); if (el) { el.textContent = val; } };
        setEl('[data-cd-d]', d);
        setEl('[data-cd-h]', pad(h));
        setEl('[data-cd-m]', pad(m));
        setEl('[data-cd-s]', pad(s));
      }
    }
    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
